<script setup>
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import VoiceAgentCard from 'dashboard/components-next/aivoice/VoiceAgentCard.vue';
import { voiceAgentsList } from '../emptyStateContent.js';

const emit = defineEmits(['click']);

const onClick = () => {
  emit('click');
};
</script>

<template>
  <EmptyStateLayout
    :title="$t('AI_VOICE.VOICE_AGENTS.EMPTY_STATE.TITLE')"
    :subtitle="$t('AI_VOICE.VOICE_AGENTS.EMPTY_STATE.SUBTITLE')"
    :action-perms="['administrator']"
  >
    <template #empty-state-item>
      <div class="grid grid-cols-1 gap-4 p-px overflow-hidden">
        <VoiceAgentCard
          v-for="agent in voiceAgentsList.slice(0, 5)"
          :id="agent.id"
          :key="`voice-agent-${agent.id}`"
          :name="agent.name"
          :description="agent.description"
          :language="agent.language"
          :voice-price="agent.voice_price"
          :active="agent.active"
          :created-at="agent.created_at"
        />
      </div>
    </template>
    <template #actions>
      <Button
        :label="$t('AI_VOICE.VOICE_AGENTS.ADD_NEW')"
        icon="i-lucide-plus"
        color="blue"
        @click="onClick"
      />
    </template>
  </EmptyStateLayout>
</template>
